import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import BookingService from './../../../../services/cargobooking.service';

export default {
  name: 'create-vendor',
  components: {
    Paginate,
    BasicSelect,
    Multiselect,
    VueElementLoading
  },
  props: ['selectedEditRowData'],
  data () {
    return {
      isLoading:false,
      updateID:'',
      vendorcode:'',
      vendorname:'',
      locationname:'',
      email:'',
      pincode:'',
      address:'',
      contactno:'',
      gstno:'',
      userName:'',
      vendorlist:[],
      clientlist:[],
      selectedClients:[],
      SupplementoryAddress : [],
    }
  },
  computed: {
  },
  async mounted () {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.isLoading = true;
    await Promise.all([
      this.getB2BMarketplaceClientlist()
    ]);
    this.isLoading = false;
    if(this.selectedEditRowData.id){
      let result = await this.getB2BVendorSupplementoryAddressDetails(this.selectedEditRowData.vendorcode);
      this.updateID = this.selectedEditRowData.id;
      this.vendorcode = this.selectedEditRowData.vendorcode;
      this.vendorname = this.selectedEditRowData.vendorname;
      this.locationname = this.selectedEditRowData.locationname;
      this.email = this.selectedEditRowData.email;
      this.pincode = this.selectedEditRowData.pincode;
      this.address = this.selectedEditRowData.address;
      this.contactno = this.selectedEditRowData.contactno;
      this.gstno = this.selectedEditRowData.gstno;
      let AssignedClientBusinessAccountId = this.selectedEditRowData.clientbusinessaccountid;
      if(this.selectedEditRowData.clientbusinessaccountid){
        this.clientlist.forEach(item => {
          if(AssignedClientBusinessAccountId.includes(item.clientbusinessaccountid.toString())){
            this.selectedClients.push({
              'clientname': item.clientname,
              'clientbusinessaccountid': item.clientbusinessaccountid
            })
          }
        });
      }
    }
  },
  methods: {
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    showCreateSellerDetailsData() {
      this.$emit("goBackToParent")
    },
    addNewRow() {
      this.SupplementoryAddress.push({
        "locationname" : null,
        "contactno": null,
        "pincode": null,
        "address": null,
        "gstno": null,
        "clientbusinessaccountid":[]
        });
    },
    deleteRow(index) {
      this.$confirm("Remove selected Supplementary Address Row.",'','question').then(()=>{
        this.SupplementoryAddress.splice(index, 1);
      });
    },
    setname(id, name){
      return name+(id);
    },
    async getB2BVendorSupplementoryAddressDetails(vendorcode){
      try {
        var AddressList = [];
        var inputPayload = {};
        inputPayload.vendorcode = vendorcode;
        let result = await BookingService.getB2BVendorSupplementoryAddressDetails(inputPayload);
        AddressList = result.data.data;
        for (var i = 0; i < AddressList.length; i++) {
          let AssignedClientBusinessAccountId = AddressList[i].clientbusinessaccountid;
          let selectedClients = [];
          if(AddressList[i].clientbusinessaccountid){
            this.clientlist.forEach(item => {
              if(AssignedClientBusinessAccountId.includes(item.clientbusinessaccountid.toString())){
                selectedClients.push({
                  'clientname': item.clientname,
                  'clientbusinessaccountid': item.clientbusinessaccountid
                })
              }
            });
          }
          this.SupplementoryAddress.push({
            "locationname" : AddressList[i].locationname,
            "contactno": AddressList[i].contactno,
            "pincode": AddressList[i].pincode,
            "address": AddressList[i].address,
            "gstno": AddressList[i].gstno,
            "clientbusinessaccountid":AddressList[i].clientbusinessaccountid,
            "selectedClients":selectedClients
          });
       }
      } catch(err){
        console.log(err);
      }
    },
    async getB2BMarketplaceClientlist(){
      try {
        var ClientList = [];
        var inputPayload = {};
        let result = await BookingService.getB2BMarketplaceClientlist(inputPayload);
        ClientList = result.data.data;
        for (var i = 0; i < ClientList.length; i++) {
          this.clientlist.push({
            'clientname': ClientList[i].clientname,
            'clientbusinessaccountid': ClientList[i].clientbusinessaccountid
          })
       }
      } catch(err){
        console.log(err);
      }
    },
    selectVendorCode(data){
      if(data){
        this.vendorcode = data.vendorcode;
        this.vendorname = data.vendorname;
        this.email = data.email;
      }
    },
    ClearVendorSelection(){
      this.vendorcode = '';
      this.vendorname = '';
      this.email = '';
    },
    async SaveVendorDetails(){
      try {
        var inputPayload = {};
        if(this.updateID){
          inputPayload.vendorid = this.updateID;
        }
        let clientbusinessaccountid = [];
        this.selectedClients.forEach(item => {
          clientbusinessaccountid.push(item.clientbusinessaccountid.toString());
        });
        inputPayload.vendorcode = this.vendorcode;
        inputPayload.vendorname = this.vendorname;
        inputPayload.locationname = this.locationname;
        inputPayload.email = this.email;
        inputPayload.pincode = this.pincode;
        inputPayload.address = this.address;
        inputPayload.contactno = this.contactno;
        inputPayload.gstno = this.gstno;

        let tempArray = [];
        for (var i = 0; i < this.SupplementoryAddress.length; i++) {
          let tempObj = this.SupplementoryAddress[i];
          let clientbusinessaccountid1 = [];
          this.SupplementoryAddress[i].selectedClients.forEach(item => {
            clientbusinessaccountid1.push(item.clientbusinessaccountid.toString());
          });
          tempObj.clientbusinessaccountid = clientbusinessaccountid1;
          tempArray.push(tempObj);
        }
        inputPayload.supplementoryaddress = tempArray;
        inputPayload.lastmodifiedby = this.userName;
        inputPayload.clientbusinessaccountid = clientbusinessaccountid;
        this.isLoading = true;
        let result = await BookingService.saveB2BVendorDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.vendorcode, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.vendorcode, "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, this.slabName, "error");
        console.log(err);
      }
    },
    onSubmit: function() {
      var self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveVendorDetails(event);
        }else{
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/B2BMarketPlace/SellerDetails/CreateSellerDetails/CreateSellerDetails.component.js